import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const fileConfirmUploadMutationAtom = createMutationAtomFactory(
  'files.confirmUpload',
  ({ fileId, checksum }: { fileId: string; checksum?: string }) => ({
    filesConfirmFileUpload: {
      __args: {
        fileID: fileId,
        checksum,
      },
      id: true,
      fileName: true,
      fileSize: true,
      mimeType: true,
      fileType: true,
      status: true,
    },
  }),
);
